import React, {Component} from "react";
import BuyerOrders from "./BuyerOrders";

class BuyerDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active:'',
            orderStatus : '',
        }
    }
    
    render() {
        return(
            <>
            <div className='row'>
                <div className='col col-lg-2 mt-5 pt-5'>
                    <div className="card mt-5 ms-5" style={{width: '15rem',position:'fixed'}}>
                    <div className="card-header bg-primary" style={{textAlign:'center'}}>
                        <h2>Menu</h2>
                    </div>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item"><button className='btn' onClick={()=> this.setState({active:'my orders', orderStatus:'all'})}  style={{width:'200px',textAlign:'left'}}>My Orders</button>
                            {this.state.active === 'my orders' ?
                            <> 
                            <ul>
                            <button className='btn' onClick={()=> this.setState({orderStatus:'new order'})} style={{width:'160px',textAlign:'left'}}>To Confirm</button><hr style={{padding: '0px',margin: '0px'}}/>
                            <button className='btn' onClick={()=> this.setState({orderStatus:'confirmed'})} style={{width:'160px',textAlign:'left'}}>To Ship</button><hr style={{padding: '0px',margin: '0px'}}/>
                            <button className='btn' onClick={()=> this.setState({orderStatus:'shipped'})} style={{width:'160px',textAlign:'left'}}>To Review</button><hr style={{padding: '0px',margin: '0px'}}/>
                            <button className='btn' onClick={()=> this.setState({orderStatus:'completed'})} style={{width:'160px',textAlign:'left'}}>Completed</button>
                            </ul>
                            </>
                            : 
                            null
                            }
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='col me-5'>
                            {
                                <BuyerOrders status={this.state.orderStatus}/>
                            }
                </div>
            </div>
            </>
    )
    }
} 
export default BuyerDashboard;